<template>
<div class="chapter">
<div class="inner_page">
<div class="epigraphPage" id="epigraphpage">
<a id="page10">
</a><a id="page11">
<div class="epigraph">
<p class="epigraphText">So holy and so perfect is my love,</p>
<p class="epigraphText">And I in such a poverty of grace,</p>
<p class="epigraphText">That I shall think it a most plenteous crop</p>
<p class="epigraphText">To glean the broken ears after the man</p>
<p class="epigraphText">That the main harvest reaps. Loose now and then</p>
<p class="epigraphText">A scattered smile, and that I’ll live upon.</p>
<p class="epigraphSource">—<em class="italic">As You Like It</em>, III. 5</p>
</div>
<div class="epigraph">
<p class="epigraphText">I sang the way I still talk. Every song was the worst way I could think of to ask for what I did not yet know how not to want.</p>
<p class="epigraphSource">—Gary Lutz, <em class="italic">Stories in the Worst Way</em></p></div>
</a></div>
<a id="page11">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004epigraphpage.vue?0df5a2a5